"use client";
import * as React from 'react';
export type Lang = 'ru' | 'en';
export function useLang(): Lang {
  const [lang, setLang] = React.useState<Lang>('ru');
  React.useEffect(() => {
    const l = (navigator.language || 'en').toLowerCase();
    setLang(l.startsWith('ru') ? 'ru' : 'en');
  }, []);
  return lang;
}
export const T = {
  signedInAs: { ru: (n: string) => `✓ Вы вошли как ${n}`, en: (n: string) => `✓ Signed in as ${n}` },
  signInIfYouHave: { ru: (d: string) => `Войти, если у вас ${d}`, en: (d: string) => `Sign in if you have ${d}` },
  copyInvite: { ru: 'Скопировать ссылку-приглашение', en: 'Copy invite link' },
  copied: { ru: 'Ссылка на встречу скопирована. Отправьте её собеседнику.', en: 'Meeting link copied. Share it with your guest.' },
  joinRoom: { ru: 'Войти в комнату', en: 'Join Room' },
  mic: { ru: 'Микрофон', en: 'Microphone' },
  cam: { ru: 'Камера', en: 'Camera' },
  yourName: { ru: 'Ваше имя', en: 'Your name' },
  slogan: { ru: 'Видеовстречи с живой транскрипцией. Заходите по ссылке, без установок.', en: 'Video meetings with live transcription. Join by link, nothing to install.' },
  createHint: { ru: 'Создай встречу. Ссылку-приглашение скопируешь на следующем экране.', en: 'Create a meeting. You will copy the invite link on the next screen.' },
  createBtn: { ru: 'Создать встречу', en: 'Create meeting' },
  gateMsg: { ru: 'Создать встречу может только вошедший. Гости заходят по ссылке без входа.', en: 'Only signed-in users can create a meeting. Guests join by link.' },
  signInToCreate: { ru: 'Войти, чтобы создать встречу', en: 'Sign in to create a meeting' },
  roomName: { ru: 'Название комнаты (необязательно)', en: 'Room name (optional)' },
};
